if(!customElements.get('wls-buybox')) {
  class WLSBuybox extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      thumbItem: '.wls-buybox__thumb-item',
      mainSlider: '.wls-buybox__slider.flickityt4s',
      customForm: '.wls-buybox__custom-form',
      flickityEnabled: 'flickityt4s-enabled',
      isSelected: 'is-selected',
    };
  }

  connectedCallback() {
    this.waitForFlickity().then(() => {
      this.initThumbnailNavigation();
    });
  
    window.addEventListener('load', () => {
      setTimeout(() => this.initThumbnailNavigation(), 0);
      setTimeout(() => this.initThumbnailNavigation(), 500);
      setTimeout(() => this.initThumbnailNavigation(), 1500);
    }, { once: true });
  
    this.initCustomButton();
  }

  disconnectedCallback() {
    const thumbsWrap = this.querySelector('.wls-buybox__thumbnails');
    if (thumbsWrap && this._thumbClickHandler) {
      thumbsWrap.removeEventListener('click', this._thumbClickHandler);
    }
    const slider = this.querySelector(this.classes.mainSlider);
    if (slider && this._sliderSelectHandler) {
      slider.removeEventListener('select.flickityt4s', this._sliderSelectHandler);
    }
  }

  waitForFlickity() {
    return new Promise((resolve) => {
      const mainSlider = this.querySelector(this.classes.mainSlider);
      if (!mainSlider) {
        resolve();
        return;
      }

      if (mainSlider.classList.contains(this.classes.flickityEnabled) || mainSlider.flickityt4s || mainSlider.flickity) {
        resolve();
        return;
      }

      const checkInterval = setInterval(() => {
        if (mainSlider.classList.contains(this.classes.flickityEnabled) || mainSlider.flickityt4s || mainSlider.flickity) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        resolve();
      }, 5000);
    });
  }

  initThumbnailNavigation() {
    const thumbItems = this.querySelectorAll(this.classes.thumbItem);
    const mainSlider = this.querySelector(this.classes.mainSlider);
    
    if (!thumbItems.length || !mainSlider) return;

    if (!mainSlider.classList.contains(this.classes.flickityEnabled)) {
      const checkReady = setInterval(() => {
        if (mainSlider.classList.contains(this.classes.flickityEnabled)) {
          clearInterval(checkReady);
          this.setupThumbnailClicks(thumbItems, mainSlider);
        }
      }, 100);
      
      setTimeout(() => clearInterval(checkReady), 5000);
    } else {
      this.setupThumbnailClicks(thumbItems, mainSlider);
    }
  }

  setupThumbnailClicks(thumbItems, mainSlider) {
    this.updateActiveThumbnail(thumbItems, mainSlider);
  
    if (this._thumbClickHandler) {
      const thumbsWrapOld = this.querySelector('.wls-buybox__thumbnails');
      if (thumbsWrapOld) thumbsWrapOld.removeEventListener('click', this._thumbClickHandler);
      this._thumbClickHandler = null;
    }
  
    const thumbsWrap = this.querySelector('.wls-buybox__thumbnails');
    if (!thumbsWrap) return;
  
    this._thumbClickHandler = (e) => {
      const thumbItem = e.target.closest(this.classes.thumbItem);
      if (!thumbItem) return;
  
      e.preventDefault();
  
      const slider = this.querySelector(this.classes.mainSlider);
      if (!slider) return;
  
      const slides = Array.from(slider.querySelectorAll('[data-main-slide]'));
  
      const mediaId = thumbItem.getAttribute('data-nt-media-id');
      let targetIndex = -1;
  
      if (mediaId) {
        targetIndex = slides.findIndex((s) => s.getAttribute('data-nt-media-id') === mediaId);
      }
  
      if (targetIndex < 0) {
        const currentThumbItems = Array.from(this.querySelectorAll(this.classes.thumbItem));
        targetIndex = currentThumbItems.indexOf(thumbItem);
      }
  
      if (targetIndex < 0) return;
  
      const flickityInstance = this.getFlickityInstance(slider);
  
      if (flickityInstance && typeof flickityInstance.select === 'function') {
        try {
          flickityInstance.select(targetIndex, false, true);
        } catch (error) {
          console.warn('Error selecting slide via Flickity:', error);
          this.selectSlideByClick(slides, targetIndex);
        }
      } else {
        this.selectSlideByClick(slides, targetIndex);
      }
    };
  
    thumbsWrap.addEventListener('click', this._thumbClickHandler);
  
    if (this._sliderSelectHandler) {
      mainSlider.removeEventListener('select.flickityt4s', this._sliderSelectHandler);
    }
  
    this._sliderSelectHandler = () => {
      const currentThumbItems = this.querySelectorAll(this.classes.thumbItem);
      const slider = this.querySelector(this.classes.mainSlider);
      if (!slider) return;
      this.updateActiveThumbnail(currentThumbItems, slider);
    };
  
    mainSlider.addEventListener('select.flickityt4s', this._sliderSelectHandler);
  }
  

  getFlickityInstance(element) {
    if (window.jQuery || window.jQuery_T4NT) {
      const $ = window.jQuery || window.jQuery_T4NT;
      const $el = $(element);
      if ($el.length) {
        const instance = $el.data('flickityt4s') || $el.data('flickity');
        if (instance) {
          if (instance.flickity) {
            return instance.flickity;
          }
          if (typeof instance.select === 'function') {
            return instance;
          }
        }
      }
    }
    
    if (element.flickityt4s) {
      const instance = element.flickityt4s;
      if (instance.flickity && typeof instance.flickity.select === 'function') {
        return instance.flickity;
      }
      if (typeof instance.select === 'function') {
        return instance;
      }
    }
    if (element.flickity && typeof element.flickity.select === 'function') {
      return element.flickity;
    }
    
    if (element.flickityt4sInstance) {
      const instance = element.flickityt4sInstance;
      if (instance.flickity && typeof instance.flickity.select === 'function') {
        return instance.flickity;
      }
      if (typeof instance.select === 'function') {
        return instance;
      }
    }
    
    const flickitySlider = element.querySelector('.flickityt4s-slider');
    if (flickitySlider) {
      if (flickitySlider.flickityt4s) {
        const instance = flickitySlider.flickityt4s;
        if (instance.flickity && typeof instance.flickity.select === 'function') {
          return instance.flickity;
        }
        if (typeof instance.select === 'function') {
          return instance;
        }
      }
      if (flickitySlider.flickity && typeof flickitySlider.flickity.select === 'function') {
        return flickitySlider.flickity;
      }
    }
    
    return null;
  }

  selectSlideByClick(slides, targetIndex) {
    const targetSlide = slides[targetIndex];
    if (!targetSlide) return;
  
    const $ = window.jQuery_T4NT || window.jQuery;
    if ($) {
      const $slider = $(targetSlide).closest('.flickityt4s');
      if ($slider.length) {
        const inst = $slider.data('flickityt4s') || $slider.data('flickity');
        const flkty = inst?.flickity || inst;
  
        if (flkty && typeof flkty.select === 'function') {
          try {
            flkty.select(targetIndex, false, true);
            return;
          } catch (e) {
            console.warn('Error selecting slide via Flickity instance:', e);
          }
        }
      }
    }
  
    targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    setTimeout(() => targetSlide.click(), 100);
  }


  updateActiveThumbnail(thumbItems, mainSlider) {
    let selectedIndex = 0;
    const flickityInstance = this.getFlickityInstance(mainSlider);
    
    if (flickityInstance && flickityInstance.selectedIndex !== undefined) {
      selectedIndex = flickityInstance.selectedIndex;
    } else {
      const selectedCell = mainSlider.querySelector(`[data-main-slide].${this.classes.isSelected}`);
      if (selectedCell) {
        const slides = Array.from(mainSlider.querySelectorAll('[data-main-slide]'));
        selectedIndex = slides.indexOf(selectedCell);
      }
    }

    const slides = mainSlider.querySelectorAll('[data-main-slide]');
    const selectedSlide = slides[selectedIndex];
    
    if (selectedSlide) {
      const selectedMediaId = selectedSlide.getAttribute('data-nt-media-id');
      thumbItems.forEach(item => {
        item.classList.remove('is-nav-selected');
        const itemMediaId = item.getAttribute('data-nt-media-id');
        if (itemMediaId === selectedMediaId) {
          item.classList.add('is-nav-selected');
        }
      });
    }
  }

  initCustomButton() {
    const customForm = this.querySelector(this.classes.customForm);
    if (!customForm) return;

    if (customForm.tagName !== 'FORM') {
      console.error('Expected FORM element but got:', customForm.tagName);
      return;
    }

    const formId = customForm.getAttribute('id');
    if (formId) {
      const defaultFormId = formId.replace('-custom', '');
      const defaultForm = document.getElementById(defaultFormId);
      if (defaultForm) {
        const defaultButton = defaultForm.querySelector('[data-atc-form]');
        if (defaultButton) {
          defaultButton.style.display = 'none';
        }
        const qtyWrapper = defaultForm.querySelector('[data-quantity-wrapper]');
        if (qtyWrapper) {
          qtyWrapper.style.display = 'none';
        }
      }
    }
    
    const redirectAttr = customForm.getAttribute('data-redirect-checkout');
    const redirectToCheckout = redirectAttr === 'true';

    customForm.addEventListener('submit', (e) => {
      e.preventDefault();
      
      const variantIdInput = customForm.querySelector('input[name="id"]');
      if (!variantIdInput) {
        console.error('Variant ID input not found');
        return;
      }
      
      const variantId = variantIdInput.value;
      const submitButton = customForm.querySelector('button[type="submit"]');
      
      if (submitButton) {
        submitButton.disabled = true;
        const originalText = submitButton.textContent;
        submitButton.textContent = 'Adding...';
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        }).then((response) => {
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          return response.json();
        }).then(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
          }
          
          if (redirectToCheckout) {
            window.location.href = '/checkout';
            return;
          }

          // Lets the slide-out cart pick the add up and open itself.
          document.dispatchEvent(
            new CustomEvent('cart:add', {
              detail: { items: [{ id: variantId, quantity: 1 }] },
              bubbles: true,
            })
          );
        }).catch((error) => {
          console.error('Error adding to cart:', error);
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
          }
          alert('Failed to add product to cart. Please try again.');
        });
      }
    });
  }
}
customElements.define('wls-buybox', WLSBuybox);
}
